import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorDropdownComponent } from './color-dropdown/color-dropdown.component';
import { ColorPickerNativeComponent } from './color-picker-native/color-picker-native.component';
import { FormsModule } from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {WhiteTooltipModule} from '@src/app/directives/whiteTooltip/white-tooltip.module';

@NgModule({
  declarations: [ColorDropdownComponent, ColorPickerNativeComponent],
  exports: [ColorDropdownComponent, ColorPickerNativeComponent],
    imports: [
        CommonModule,
        FormsModule,
        FontAwesomeModule,
        WhiteTooltipModule,
    ]
})
export class ColorPickerModule { }
